// ----------------------------------------------------------------------

export default function Button(theme) {
  return {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 24,
          textTransform: 'none',
          fontWeight: 600,
          letterSpacing: 0,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        sizeSmall: {
          height: 34,
          padding: '4px 14px',
          fontSize: '0.8125rem',
          borderRadius: 20,
        },
        sizeMedium: {
          height: 42,
          padding: '8px 20px',
          fontSize: '0.875rem',
          borderRadius: 24,
        },
        sizeLarge: {
          height: 48,
          padding: '10px 24px',
          fontSize: '0.9375rem',
          borderRadius: 24,
        },
        containedPrimary: {
          backgroundColor: theme.palette.primary.main,
          color: '#FFFFFF',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
            boxShadow: 'none',
          },
        },
        containedSecondary: {
          backgroundColor: theme.palette.grey[800],
          color: '#FFFFFF',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: theme.palette.grey[900],
            boxShadow: 'none',
          },
        },
        containedInherit: {
          color: theme.palette.grey[800],
          backgroundColor: '#F3F4F6',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#E5E7EB',
            boxShadow: 'none',
          },
        },
        outlinedInherit: {
          borderColor: theme.palette.divider,
          color: theme.palette.text.primary,
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
            borderColor: theme.palette.grey[400],
          },
        },
        outlinedPrimary: {
          borderColor: theme.palette.primary.main,
          color: theme.palette.primary.main,
          '&:hover': {
            backgroundColor: theme.palette.primary.lighter,
          },
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
    },
  };
}
